import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { Box } from '@material-ui/core';

const Footer = () => {

  return (
    <Box>
		<Typography align="center" variant="overline" component="h3">
      		<Link color="primary" href="https://github.com/kapustiansky/geek-iconfont"> 
	  			{' Geek-iconfont Repo.'}
      		</Link>
      		{new Date().getFullYear()}
		</Typography>
    </Box>
  );
};

export default Footer;